import React, { use, useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Tooltip } from "primereact/tooltip";
import { Skeleton } from "primereact/skeleton";
import { useForm, Controller } from "react-hook-form";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import CustomeButton from "../../../components/Button/index";
import useDateTime from "../../../hooks/useDateTime";
import { toZonedTime } from "date-fns-tz";
import UserTimezone from "~/Pages/EntityCalendar/components/UserTimezone";
import { InputText } from "primereact/inputtext";
import { format, parse } from "date-fns";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";

const MilestonesDetailsSidebar = ({ process, allservices, isLoader }) => {
  const { formatDateTime, dateTimeToTimezone } = useDateTime();
  const [dueDateInUserTimezone, setDueDateInUserTimezone] = useState(null);
  const { timezone } = useSelector((state) => state.login);
  const [generaldata, setGeneraldata] = useState({
    ...process,
    service_line: allservices?.find((x) => x.id === process?.service),
    time: process?.due_date,
  });
  const { role } = useSelector((state) => state.login);
  const [toggle, setToggle] = useState(false);

  const handleToggle = () => {
    setToggle((prv) => !prv);
  };
  const {
    control,
    reset,
    // formState: { errors },
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onChange",
    defaultValues: generaldata,
  });

  useEffect(() => {
    const safeData = generaldata || {};
    reset(safeData);
  }, [generaldata, reset]);

  const handleChange = (name, value) => {
    setGeneraldata((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (!generaldata?.due_date) return;
    setDueDateInUserTimezone(toZonedTime(generaldata?.due_date, timezone));
  }, [timezone, generaldata?.due_date]);
  let formattedGeneralTime = formatDateTime({ date: generaldata?.time });

  const getDueDateTimeValue = () => {
    const dueDate =
      toZonedTime(generaldata?.due_date, generaldata?.entityData?.timezone) ||
      null;
    return `${format(dueDate, "hh:mm a")} | ${generaldata?.entityData?.timezone}`;
  };

  const formatDateRange = (dateRangeStr) => {
    if (!dateRangeStr) return "";

    const [startStr, endStr] = dateRangeStr.split("-");

    const startDate = parse(startStr, "dd/MM/yyyy", new Date());
    const endDate = parse(endStr, "dd/MM/yyyy", new Date());

    const formattedStart = format(startDate, "MMM do, yyyy");
    const formattedEnd = format(endDate, "MMM do, yyyy");

    return `${formattedStart} - ${formattedEnd}`;
  };

  return (
    <div className="formgrid grid proccess-details">
      {process?.serviceData?.name !== "Payroll +" && (
        <>
          <div className="col-12 mb-3">
            <Tooltip target=".info-icon" />
            <label className="input-label">Entity*</label>
            <div className="calendar-container mt-2">
              {isLoader ? (
                <Skeleton
                  data-testid="skeleton-loader"
                  className="p-4"
                ></Skeleton>
              ) : (
                <div className="p-inputgroup">
                  <div className="p-inputtext p-component p-disabled w-full entity-container">
                    <div
                      className="flex align-items-center gap-2 entity-container-flow"
                      style={{
                        minWidth: 0,
                        overflow: "hidden",
                      }}
                    >
                      <span className="entityname">
                        {generaldata?.entityData?.name}
                      </span>
                      <span style={{ flexShrink: 0 }}>
                        (
                        <ReactCountryFlag
                          countryCode={generaldata?.entityData?.country || ""}
                          svg
                          className=""
                        />{" "}
                        {getName(generaldata?.entityData?.country || "")})
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="col-12 mb-3">
            <Tooltip target=".info-icon" />
            <label className="input-label">
              Start Date*
              <span
                className="info-icon ml-1 pi pi-info-circle"
                id="start_date"
              />
              <Tooltip
                target="#start_date"
                content="This date and time are based on the entity's time zone, which may differ from your local time."
                position="bottom"
                className="calendar-tooltip"
              />
            </label>
            <div className="calendar-container mt-2">
              {isLoader ? (
                <Skeleton
                  data-testid="skeleton-loader"
                  className="p-4"
                ></Skeleton>
              ) : (
                <Controller
                  name="start_date"
                  control={control}
                  render={({ field }) => {
                    const zonedDate = generaldata?.start_date
                      ? toZonedTime(
                          generaldata?.start_date,
                          generaldata?.entityData?.timezone,
                        )
                      : null;
                    const formattedDate = zonedDate
                      ? format(zonedDate, "MMMM do, yyyy")
                      : null;
                    const isDisabled = true;
                    return (
                      <>
                        {isDisabled ? (
                          <InputText
                            value={formattedDate}
                            readOnly
                            className="w-full"
                            placeholder="Select date"
                            disabled={true}
                          />
                        ) : (
                          <Calendar
                            {...field}
                            onChange={(e) => {
                              const isoDate = e.value
                                ? e.value.toISOString()
                                : "";
                              field.onChange(isoDate);
                              handleChange("start_date", isoDate);
                            }}
                            value={
                              generaldata?.start_date
                                ? toZonedTime(
                                    generaldata?.start_date,
                                    generaldata?.entityData?.timezone,
                                  )
                                : null
                            }
                            disabled
                            dateFormat="MM d, yy"
                            placeholder="Select date"
                            className="w-full"
                            data-testid="lsp-select-date"
                          />
                        )}
                        <span
                          className="pi pi-calendar input-icon "
                          data-testid="input-icon"
                        ></span>
                      </>
                    );
                  }}
                />
              )}
            </div>
          </div>
        </>
      )}

      <div className="col-12">
        <Tooltip target=".info-icon" />
        <label className="input-label">
          Due Date*
          <span className="info-icon ml-1 pi pi-info-circle" id="due_date" />
          <Tooltip
            target="#due_date"
            content="This date and time are based on the entity's time zone, which may differ from your local time."
            position="bottom"
            className="calendar-tooltip"
          />
        </label>
        <div className="calendar-container mt-2">
          {isLoader ? (
            <Skeleton data-testid="skeleton-loader" className="p-4"></Skeleton>
          ) : (
            <Controller
              name="due_date"
              control={control}
              render={({ field }) => {
                const zonedDate = generaldata?.due_date
                  ? toZonedTime(
                      generaldata?.due_date || field.value,
                      generaldata?.entityData?.timezone,
                    )
                  : null;
                const formattedDate = zonedDate
                  ? format(zonedDate, "MMMM do, yyyy")
                  : null;
                const isDisabled = true;
                return (
                  <>
                    {isDisabled ? (
                      <InputText
                        value={formattedDate}
                        readOnly
                        className="w-full"
                        placeholder="Select date"
                        disabled
                      />
                    ) : (
                      <Calendar
                        {...field}
                        onChange={(e) => {
                          const isoDate = e.value ? e.value.toISOString() : "";
                          field.onChange(isoDate);
                          handleChange("due_date", isoDate);
                        }}
                        value={
                          generaldata?.due_date
                            ? toZonedTime(
                                generaldata.due_date,
                                generaldata?.entityData?.timezone,
                              )
                            : null
                        }
                        disabled
                        dateFormat="MM d, yy"
                        placeholder="Select date"
                        className="w-full"
                        data-testid="lsp-select-date"
                      />
                    )}
                    <span
                      className="pi pi-calendar input-icon"
                      data-testid="input-icon"
                    ></span>
                  </>
                );
              }}
            />
          )}
        </div>
      </div>
      <div className="col-12 pt-3 flex flex-column gap-2">
        <div className="calendar-container">
          {isLoader ? (
            <Skeleton data-testid="skeleton-loader" className="p-4"></Skeleton>
          ) : (
            <Controller
              name="time"
              control={control}
              render={({ field }) => (
                <>
                  <InputText
                    {...field}
                    onChange={(e) => {
                      const utcDate = dateTimeToTimezone({ date: e.value });
                      field.onChange(utcDate.toISOString());
                      handleChange("time", utcDate.toISOString());
                    }}
                    disabled
                    value={
                      generaldata?.due_date
                        ? getDueDateTimeValue()
                        : field.value
                    }
                    readOnlyInput
                    placeholder="Select time"
                    className={`appearance-none outline-none w-full`}
                  />
                  <span
                    className="pi pi-clock input-icon"
                    data-testid="input-icon"
                  ></span>
                </>
              )}
            />
          )}
        </div>
        <UserTimezone dueDate={dueDateInUserTimezone} timezone={timezone} />
      </div>

      <div
        className={`col-12 pt-3 toggle-milestone-panel ${toggle ? "open" : ""}`}
      >
        {toggle && (
          <>
            <label className="input-label">Service line*</label>
            <div className="calendar-container">
              {isLoader ? (
                <Skeleton
                  data-testid="skeleton-loader"
                  className="p-4"
                ></Skeleton>
              ) : (
                <Controller
                  name="service_line"
                  control={control}
                  render={({ field }) => (
                    <>
                      {process?.serviceData?.name === "Payroll +" ? (
                        <div className="field">
                          <InputText
                            value={"Payroll Plus"}
                            placeholder="Select Service Line"
                            name="email"
                            className="appearance-none outline-none w-full mt-2"
                            disabled
                            multiple={true}
                          />

                          <span className={"input-icon-lock"}>
                            <i className="pi pi-lock"></i>
                          </span>
                        </div>
                      ) : (
                        <Dropdown
                          {...field}
                          onChange={(e) => {
                            field.onChange(e.value);
                            handleChange("service_line", e.value);
                          }}
                          value={generaldata?.service_line || ""}
                          options={allservices}
                          optionLabel="name"
                          placeholder="Service line"
                          className={`appearance-none outline-none w-full mt-2`}
                          disabled
                        />
                      )}
                    </>
                  )}
                />
              )}
            </div>
          </>
        )}
      </div>
      {process?.serviceData?.name === "Payroll +" && (
        <div
          className={`col-12 toggle-milestone-panel ${toggle ? "open" : ""}`}
        >
          {toggle && (
            <>
              <label className="input-label">Period</label>
              <div className="calendar-container">
                {isLoader ? (
                  <Skeleton
                    data-testid="skeleton-loader"
                    className="p-4"
                  ></Skeleton>
                ) : (
                  <Controller
                    name="service_line"
                    control={control}
                    render={({ field }) => (
                      <>
                        {process?.serviceData?.name === "Payroll +" ? (
                          <div className="field">
                            <InputText
                              value={formatDateRange(process?.payrun)}
                              placeholder="Select Service Line"
                              name="email"
                              className="appearance-none outline-none w-full mt-2 w-full mt-2 text-overflow-ellipsis white-space-nowrap overflow-hidden"
                              disabled
                            />
                            <span className={"input-icon-lock"}>
                              <i className="pi pi-lock"></i>
                            </span>
                          </div>
                        ) : (
                          <Dropdown
                            {...field}
                            onChange={(e) => {
                              field.onChange(e.value);
                              handleChange("service_line", e.value);
                            }}
                            value={generaldata?.service_line || ""}
                            options={allservices}
                            optionLabel="name"
                            placeholder="Service line"
                            className={`appearance-none outline-none w-full`}
                            disabled
                          />
                        )}
                      </>
                    )}
                  />
                )}
              </div>
            </>
          )}
        </div>
      )}
      {toggle ? (
        <div className="col-12 pt-3">
          <CustomeButton
            label="View Less"
            variant="outlined"
            className="mr-2 w-full toggle__btn"
            icon="pi pi-angle-up"
            iconPos="right"
            onClick={handleToggle}
          />
        </div>
      ) : (
        !isLoader && (
          <div className="col-12">
            <CustomeButton
              label="View More"
              variant="outlined"
              className="mr-2 w-full toggle__btn"
              icon="pi pi-angle-down"
              iconPos="right"
              onClick={handleToggle}
            />
          </div>
        )
      )}
    </div>
  );
};
MilestonesDetailsSidebar.propTypes = {
  process: PropTypes.object,
  allservices: PropTypes.array,
  isLoader: PropTypes.bool,
};
export default MilestonesDetailsSidebar;
